import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const comboboxDividerFn = /* @__PURE__ */ createRecipe('combobox-divider', {}, [])

const comboboxDividerVariantMap = {}

const comboboxDividerVariantKeys = Object.keys(comboboxDividerVariantMap)

export const comboboxDivider = /* @__PURE__ */ Object.assign(memo(comboboxDividerFn.recipeFn), {
  __recipe__: true,
  __name__: 'comboboxDivider',
  __getCompoundVariantCss__: comboboxDividerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: comboboxDividerVariantKeys,
  variantMap: comboboxDividerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, comboboxDividerVariantKeys)
  },
  getVariantProps: comboboxDividerFn.getVariantProps,
})